import {BUSCAR_CUPONS, BUSCAR_TIPOS, DETERMINAR_PAGINA_ATUAL_CUPONS, ALTERAR_NUMERO_REGISTROS_POR_PAGINA_CUPONS, BUSCAR_TIPOS_ORIGENS_REQUISICAO_CUPOM} from '../../actions/cupom/cuponsActions';

const initialState = {
  cupons: [],
  tipos: [],
  origensRequisicaoCupom: [],
  paginaAtualCupons: 1,
  registrosPorPaginaCupons: 10,
  total: 0
}

export default function reducerCupom (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_CUPONS: {
      const {cupons, total} = action.payload;
      if (cupons) {
        return {
          ...state,
          cupons: cupons,
          total: total
        }
      }
      return []
    }

    case BUSCAR_TIPOS: {
      const {tipos} = action.payload;
      if (tipos) {
        return {
          ...state,
          tipos: tipos
        }
      }
      return []
    }

    case DETERMINAR_PAGINA_ATUAL_CUPONS: {
      return {
        ...state,
        paginaAtualCupons: action.payload
      };
    }

    case ALTERAR_NUMERO_REGISTROS_POR_PAGINA_CUPONS: {
      return {
        ...state,
        registrosPorPaginaCupons: action.payload
      };
    }

    case BUSCAR_TIPOS_ORIGENS_REQUISICAO_CUPOM: {
      const {origensRequisicaoCupom} = action.payload;

      if (origensRequisicaoCupom) {
        return {
          ...state,
          origensRequisicaoCupom: origensRequisicaoCupom
        }
      }
      return []
      
    }

    default: {
      return state
    }
  }
}

